import { useQuery } from '@tanstack/react-query';
import { getAuthCookies } from '@webmotors/consumer-shared-auth';
import { advertiserService } from './advertiser.service';
import type { TAdvertiserProfile } from './advertiser.service';

type TUseAdvertiserProfileReturn = {
	profile: TAdvertiserProfile | null;
	isLoading: boolean;
	isError: boolean;
};

/**
 * Busca o perfil do anunciante (`acesso/dados-usuario`) usado para montar o
 * bloco `user` do objDataLayer. Só dispara quando há `idToken` — em paridade
 * com a garagem, que só preenche `user` quando o anunciante está autenticado.
 * O resultado é cacheado pelo React Query e compartilhado entre todas as
 * chamadas de `useAnalytics`.
 */
const useAdvertiserProfile = (): TUseAdvertiserProfileReturn => {
	const { idToken } = getAuthCookies();

	const { data, isLoading, isError } = useQuery({
		queryKey: ['advertiser', 'profile'],
		queryFn: () => advertiserService.getUserData(),
		enabled: Boolean(idToken),
		staleTime: 5 * 60_000
	});

	return {
		profile: data ?? null,
		isLoading,
		isError
	};
};

export { useAdvertiserProfile };
export type { TUseAdvertiserProfileReturn };
